import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { Box, Divider, Typography } from '@material-ui/core';
import Button from 'components/V2/Button';
import Input from 'components/V2/Input';
import { useFormik } from 'formik';
import useApiHandler from 'hooks/useApiHandler';

import { openToast } from 'redux/actions/toaster';
import { storeBearerToken } from 'redux/slices/general';
import { useLogin } from 'redux/slices/loginApi';

import classes from '../commonStlyes.module.css';
import styles from './login.module.css';

import { ReactComponent as EyeOn } from 'asset/IconsPack/hx_eye-filled.svg';
import { ReactComponent as EyeOff } from 'asset/IconsPack/hx_eye-off-filled.svg';

import {
    loginFormInitialValues as initialValues,
    loginFormValidationSchema as validationSchema,
} from '../validations';

const Login = () => {
    const [passwordType, setPasswordType] = useState(true);
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const [login] = useLogin();
    const apiHandler = useApiHandler();

    const handleLogin = async (values) => {
        const response = await apiHandler(login, values);

        if (response?.data) {
            dispatch(storeBearerToken(response?.data?.token));
            history.push('/2fa');
        } else if (response.error) {
            dispatch(
                openToast({
                    variant: 'error',
                    message: response?.error?.data?.errorMessage,
                })
            );
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleLogin,
    });

    const { setFieldValue } = formik;

    useEffect(() => {
        if (location?.state?.companyEmail) {
            setFieldValue('email', location.state?.companyEmail);
        }
    }, [location, setFieldValue]);

    return (
        <Box className={classes.formContainer}>
            <Typography component={'h2'} className={classes.formHeading}>
                Welcome
            </Typography>
            <Typography className={classes.formSubHeading}>
                Enter your login details to proceed
            </Typography>
            <Divider className={classes.divider} />
            <form className={styles.loginForm} onSubmit={formik.handleSubmit}>
                <Box className={styles.emailInput}>
                    <Input
                        type="text"
                        label="Email"
                        name="email"
                        value={formik.values.email}
                        placeholder="you@example.com"
                        variant="outlined"
                        autoFocus
                        handleChange={formik.handleChange}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                    />
                </Box>
                <Box className={styles.passwordInput}>
                    <Input
                        type={passwordType ? 'password' : 'text'}
                        variant="outlined"
                        label="Password"
                        name="password"
                        value={formik.values.password}
                        placeholder="Enter password"
                        endAdornment={formik.values.password}
                        EndAdornmentIcon={passwordType ? EyeOff : EyeOn}
                        emdAdormentIconClass={styles.eyeIcon}
                        endAdormentClick={() => setPasswordType(!passwordType)}
                        handleChange={formik.handleChange}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.touched.password && formik.errors.password}
                    />

                    <Link to="/forgot-password" className={styles.forgotPasswordCta}>
                        Forgot Password?
                    </Link>
                </Box>

                <Button type="submit" intent="primary" size="lg" className={classes.formBtn}>
                    Login
                </Button>
            </form>
            <Box className={classes.formBottomLine}>
                <Typography className={classes.bottomText}>Don’t have an account?</Typography>
                <Link className={classes.cta} to="/register">
                    Register
                </Link>
            </Box>
        </Box>
    );
};

export default Login;
